export default function Hero() {
  return (
    <section id="hero" className="min-h-screen flex items-center justify-center relative overflow-hidden px-6">
      {/* Background glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-violet-900/20 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <div className="flex flex-wrap justify-center gap-3 mb-6">
          <span className="inline-block text-xs font-medium tracking-widest text-violet-400 uppercase border border-violet-400/30 px-4 py-1.5 rounded-full">
            Available for new projects
          </span>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-indigo-300 uppercase border border-indigo-400/30 px-4 py-1.5 rounded-full">
            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2a10 10 0 110 20A10 10 0 0112 2zm0 2a8 8 0 100 16A8 8 0 0012 4zm1 4v4.586l3.707 3.707-1.414 1.414L11 13.414V8h2z"/>
            </svg>
            AI-accelerated development
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6">
          I build digital products<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-indigo-400">
            faster, with AI.
          </span>
        </h1>

        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed">
          20+ years of experience building web apps, mobile apps, and enterprise solutions —
          now accelerated with AI to ship better products in less time.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#portfolio"
            className="bg-violet-600 hover:bg-violet-500 text-white font-medium px-8 py-3.5 rounded-lg transition-colors text-sm">
            See My Work
          </a>
          <a href="#contact"
            className="border border-white/10 hover:border-white/30 text-gray-300 hover:text-white font-medium px-8 py-3.5 rounded-lg transition-colors text-sm">
            Start a Project
          </a>
        </div>

        {/* Tech stack badges */}
        <div className="mt-16 flex flex-wrap justify-center gap-3">
          {['React', 'Node.js', 'iOS', 'Android', 'Blazor / C#', 'AI Integration'].map(tech => (
            <span key={tech} className="text-xs text-gray-500 border border-white/5 bg-white/[0.03] px-4 py-1.5 rounded-full">
              {tech}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
